import { createContext, useState } from 'react'

export const ReplayMouseContext = createContext()

export const ReplayMouseProvider = ({ children }) => {
  const [mousePos, setMousePos] = useState({ x: 0.5, y: 0.5 }) 
  const [isClicking, setIsClicking] = useState(false)

  return (
    <ReplayMouseContext.Provider value={{ 
        mousePos, 
        setMousePos,
        isClicking,
        setIsClicking
    }}>
      {children}
    </ReplayMouseContext.Provider>
  )
}